import WebIMConfig from './WebIMConfig';
import store from '@/store/index';
import { setMsgInfo } from '@/views/Voice/store/module/msgInfo';
import { setMsgConfig } from '@/views/Voice/store/module/msgConfig';
import { setRepeatInfo } from '@/views/Voice/store/module/repeatInfo';
import VoiceFn from '@/views/Voice/fn';
import { message } from 'antd';
import { getShowUserInfo } from '../config';

export function initWebIM() {
  const WebIM = (window as any).WebIM;
  WebIM.config = WebIMConfig;
  WebIM.conn = new WebIM.connection({
    appKey: WebIM.config.appkey,
    isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
    https: WebIM.config.https,
    isAutoLogin: true,
    heartBeatWait: WebIM.config.heartBeatWait,
    autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
    autoReconnectInterval: WebIM.config.autoReconnectInterval,
    isStropheLog: WebIM.config.isStropheLog,
    delivery: WebIM.config.delivery,
    isHttpDNS: WebIM.config.isHttpDNS,
    isDebug: false,
    isFixedDeviceId: false
  });
  WebIM.logger.disableAll();
}

export function toLogin(uid: number) {
  (window as any).WebIM.conn.open({
    user: `User${uid}`,
    pwd: `Pwd${uid}`,
    appKey: WebIMConfig.appkey
  });
}

export function toLogout() {
  (window as any).WebIM.conn.close();
}

export function joinChatRoom(info: any) {
  (window as any).WebIM.conn.joinChatRoom({
    roomId: info.chatroomId,
    success: () => {
      console.log('加入聊天室成功');
      // setTimeout(() => {
      //   // const { chatroomId, uid, nickname, liveNo, authInfo, isSend } = info;
      //   // sendEnterStudio(chatroomId, uid, nickname, liveNo, authInfo, isSend);
      //   sendEnterStudio('216848991846405', '31258997', '北凉五五开', '104618616', 1, 1);
      // }, 1500);
    },
    error: () => {
      console.log('加入聊天室失败');
    }
  });
}

// sendEnterStudio('216848991846405', '31258997', '北凉五五开', '104618616', 1, 1)
export function sendEnterStudio(chatroomId: any, uid: any, nickname: string, liveNo: any, authInfo: any, isSend: any) {
  const WebIM = (window as any).WebIM;
  console.log('发送信息-进入聊天室');
  const id = WebIM.conn.getUniqueId();
  let msg = new WebIM.message('custom', id);
  const customEvent = 'enter_room2';
  const customExts = {
    uid: uid,
    nickname: nickname,
    live_no: liveNo,
    auth_icon: authInfo || 1
  };
  msg.set({
    to: chatroomId,
    customEvent,
    customExts,
    ext: customExts,
    chatType: 'chatRoom',
    success: () => {
      console.log('发送信息-进入聊天室-成功');
    },
    fail: (error: any) => {
      console.log('发送信息-进入聊天室-失败', error);
    }
  });
  WebIM.conn.send(msg.body);
}

export interface errorCodeListJson {
  type: number;
  msg: string;
}

export const errorCodeList: errorCodeListJson[] = [
  {
    type: 219,
    msg: '您已被禁言'
  },
  {
    type: 500,
    msg: '服务器忙碌'
  },
  {
    type: 501,
    msg: '抱歉，包含敏感内容，请修改后再试！'
  },
  {
    type: 502,
    // msg: '消息被拦截'
    msg: '抱歉，包含敏感内容，请修改后再试！'
  },
  {
    type: 503,
    msg: '错误信息超出 SDK 处理范围'
  },
  {
    type: 507,
    msg: '您已被禁言'
  },
  {
    type: 508,
    // msg: '消息被 Moderation 服务拦截'
    msg: '抱歉，包含敏感内容，请修改后再试！'
  },
  {
    type: 509,
    msg: '发送消息超出频率限制'
  },
  {
    type: 602,
    msg: '当前不在聊天室'
  },
  {
    type: 603,
    msg: '被封禁，无法发送消息'
  },
  {
    type: 604,
    msg: '消息回调函数内部错误'
  },
  {
    type: 605,
    msg: '聊天室不存在'
  },
  {
    type: 705,
    msg: '聊天室不存在'
  },
  {
    type: 999,
    msg: 'Websocket 发送消息错误'
  }
];

export function returnErrorMsg(type: number, isObj?: boolean) {
  for (let i = errorCodeList.length - 1; i >= 0; i--) {
    if (errorCodeList[i].type === type) {
      if (isObj) {
        return errorCodeList[i];
      }
      return errorCodeList[i].msg;
    }
  }
  return 'send msg error';
}

export function sendRoomText(
  msgContent: string,
  uid: number,
  roomId: any,
  nickname: any,
  chatroomId: string,
  isHomeowner: boolean,
  sendImg: any,
  authInfo: any,
  roleId: number,
  sex: number,
  svipEffect?: any,
  denoiseHidden?: boolean
) {
  const WebIM = (window as any).WebIM;
  const msgConfig = VoiceFn.getLocalInfo('msgConfig');
  let id = WebIM.conn.getUniqueId();
  let msg = new WebIM.message('txt', id);
  const roomInfo = VoiceFn.getLocalInfo('roomInfo');
  const modelType = roomInfo?.modelType || 0;
  const localAnchorLiveId = localStorage.getItem('VOICE-LIVE-ANCHOR-LIVEID');
  const liveNo = modelType === 2 ? localAnchorLiveId : '';
  let option = {
    msg: msgContent,
    to: chatroomId,
    chatType: 'chatRoom',
    ext: {
      uid,
      roomId: roomId.toString(),
      nickname,
      isHomeowner,
      live_no: liveNo,
      head_img: sendImg,
      auth_icon: authInfo,
      authIcon: authInfo && authInfo.flagTheme ? authInfo.flagTheme.simpleIconUrl : '',
      roleId,
      svip_effect: svipEffect || '',
      sex,
      onAppId: '10001',
      denoiseHidden: denoiseHidden ?? false,
      ...getShowUserInfo(roomInfo?.user_96show)
    },
    success: () => {
      store.dispatch(
        setMsgConfig({
          ...msgConfig,
          msg: '',
          state: 2,
          errorMsg: ''
        })
      );
      store.dispatch(
        setMsgInfo({
          msgItem: {
            msgTypeId: 1,
            msgType: 'TEXT',
            userId: uid,
            isHomeowner,
            userName: nickname,
            authIcon: authInfo && authInfo.flagTheme ? authInfo.flagTheme.simpleIconUrl : '',
            headImg: sendImg,
            content: msgContent,
            roomId,
            noHistroy: true,
            time: Date.now(),
            roleId,
            svip_effect: svipEffect || '',
            sex,
            onAppId: '10001',
            ...getShowUserInfo(roomInfo?.user_96show)
          }
        })
      );
    },
    fail: (error: any) => {
      console.log('发送文本信息失败', error);
      const infoObj: any = returnErrorMsg(error.type, true);
      if (infoObj.type === 602) {
        const repeatInfo = VoiceFn.getLocalInfo('repeatInfo');
        store.dispatch(
          setRepeatInfo({
            ...repeatInfo,
            reloadType: 'REPEATIMLOGIN',
            reloadTitle: msgContent,
            reloadTime: Date.now()
          })
        );
        message.info('当前不在聊天室，正在重新连接，请稍等');
      } else {
        store.dispatch(
          setMsgConfig({
            ...msgConfig,
            state: 3,
            errorMsg: returnErrorMsg(error.type)
          })
        );
      }
    }
  };
  console.log(option);
  msg.set(option);
  WebIM.conn.send(msg.body);
}

export function showLocalSignChat(msgInfo: any) {
  const msgConfig = VoiceFn.getLocalInfo('msgConfig');
  const receiverInfo = JSON.parse(msgInfo.receiverInfo);
  store.dispatch(
    setMsgConfig({
      ...msgConfig,
      msg: '',
      state: 2,
      errorMsg: ''
    })
  );
  store.dispatch(
    setMsgInfo({
      msgItem: {
        mid: Date.now() + msgInfo.uid + 996,
        msgTypeId: 1,
        msgType: 'PRIVATE_TEXT',
        isSdk: false,
        isHomeowner: msgInfo.isHomeowner,
        userId: msgInfo.uid,
        userName: msgInfo.nickname,
        authIcon: msgInfo.authIcon,
        headImg: msgInfo.head_img,
        content: msgInfo.msg,
        roomId: msgInfo.roomId,
        noHistroy: true,
        time: Date.now(),
        roleId: msgInfo.roleId,
        svip_effect: msgInfo.svip_effect,
        sex: msgInfo.sex,
        isUser: true,
        receiverInfo
      }
    })
  );
}

export function sendFollowStudio(chatroomId: any, uid: any, nickname: any, liveNo: any, authInfo: any) {
  const WebIM = (window as any).WebIM;
  console.log('发送关注主播');
  const id = WebIM.conn.getUniqueId();
  let msg = new WebIM.message('custom', id);
  const customEvent = 'do_follow';
  const customExts = {
    uid: uid,
    nickname: nickname,
    live_no: liveNo,
    auth_icon: authInfo
  };
  msg.set({
    to: chatroomId,
    customEvent,
    customExts,
    ext: customExts,
    chatType: 'chatRoom',
    success: () => {
      console.log('发送关注主播成功');
    },
    fail: () => {
      console.log('发送关注主播失败');
    }
  });
  WebIM.conn.send(msg.body);
}
